/**
 * Functions to show/hide conditional content based on user selections
 * Currently supports only checkbox and radio
 * 
 * Markup example:
 * <form class="js-form-conditional">
 *  <input class="js-show-content" aria-controls="demo" type="checkbox" />
 *  <div class="hidden" id="demo">
 *    <input type="text" >
 *    <input type="text" class="required">
 *  </div>
 * </form>
 */
export class FormWithConditionals {
  private form: Element;   

  constructor(private formElement: Element) {
    this.form = formElement;
  }

  /**
   * Attach handler for input
   * Currently supports only checkbox and radio inputs
   */
  public attachHandler(input:HTMLInputElement, extra:Element) {
    if(input.type === 'checkbox') {
      input.addEventListener('change', () => {
        input.checked ? this.openElement(extra) : this.closeElement(extra);
      });
    } else if(input.type === 'radio') {
      const siblings = Array.from(this.form.querySelectorAll('input[name="' + input.getAttribute('name') + '"]'));
      siblings.forEach((sibling) => {
        sibling.addEventListener('change', () => {
          input.checked ? this.openElement(extra) : this.closeElement(extra);
        });
      });
    }
  }

  /**
  * Open element and set field requirements
  * @param element - container for extra content
  */
  private openElement(element:Element){
    element.classList.remove('hidden');
    const requiredFields = Array.from(element.getElementsByClassName('required')); 
    requiredFields.forEach((input:Element) => {
      input.setAttribute('required','required');
    })
  }

  /**
  * Close element and remove field requirements
  * @param element - container for extra content
  */
  private closeElement(element:Element){
    element.classList.add('hidden');
    const requiredFields = Array.from(element.getElementsByClassName('required')); 
    requiredFields.forEach((input:Element) => {
      input.removeAttribute('required');
    })
  }

  /**
   * Add conditional content functionality to given form element
   */
  public init() {
    const inputs = Array.from(this.form.querySelectorAll('.js-show-form-conditional'));

    inputs.forEach((input:HTMLInputElement) => {
      const targetId = input.getAttribute('aria-controls')
      const extraContent = document.getElementById(targetId);

      //handle content visibility and required fields
      if(input.type === 'checkbox' || input.type === 'radio' ) {
        input.checked ? this.openElement(extraContent ) : this.closeElement(extraContent);
      }

      this.attachHandler(input, extraContent);
    });
  }

}

